import {Heading, Image, Link, River, Text} from '@primer/react-brand'
import type {RiverProps} from '@primer/react-brand'

import {getImageSources} from '@github-ui/swp-core/lib/utils/images'

import {AssetTypeEnum} from '../../../lib/types/contentful/contentTypes/assetItem'
import {AssetVideo} from './Video'
import {renderWithNoMarks} from '../utils'
import type {LabelAssetLinkItem} from '../../../lib/types/contentful/contentTypes/labelAssetLinkItem'

export type FeaturedStackProps = {
  items?: LabelAssetLinkItem[]
}

const RIVER_ALIGNMENTS: Array<RiverProps['align']> = ['start', 'end']

export const FlexSuiteRiverStack = ({items}: FeaturedStackProps) => {
  if (!items || items.length === 0) return null

  return (
    <>
      {items.map((item, index) => {
        const {
          heading,
          description,
          href,
          label,
          assetType,
          optionImage,
          optionVideo,
          optionPoster,
          autoplay,
          videoSource,
        } = item.fields
        const align = RIVER_ALIGNMENTS[index % RIVER_ALIGNMENTS.length]

        return (
          <River key={item.sys.id} align={align}>
            <River.Visual>
              {assetType === AssetTypeEnum.enum.Image && optionImage && (
                <Image
                  as="picture"
                  src={`${optionImage.fields.file.url}?fm=webp`}
                  sources={getImageSources(optionImage.fields.file.url, {maxWidth: 720})}
                  alt={optionImage.fields.description ?? ''}
                />
              )}
              <AssetVideo
                assetType={assetType}
                optionVideo={optionVideo}
                optionPoster={optionPoster}
                autoplay={autoplay}
                videoSource={videoSource}
              />
            </River.Visual>
            <River.Content>
              <Heading as="h3" size="5">
                {renderWithNoMarks(heading)}
              </Heading>
              <Text>{renderWithNoMarks(description)}</Text>
              <Link href={href}>{label}</Link>
            </River.Content>
          </River>
        )
      })}
    </>
  )
}
